<template>
  <li
    :class="{'mobile-table-cell': true, 'seperator-lines': seperatorLines}"
    :style="{'border-left-color': statusColour, 'height': `${height}px`}"
    @click.prevent="onClicked">

    <span class="cell-title">{{title}}<slot name="title" /></span>
    <div class="cell-content">
      <slot />
    </div>
    <i class="far fa-chevron-right mobile-table-cell-accessory" :style="{'line-height': `${height}px`}" v-if="accessory && !showDelete"></i>
    <transition name="fade">
      <button class="mobile-table-cell-delete" :style="{'line-height': `${height}px`}" @click="onDeleteClicked" v-if="showDelete">
        <i class="far fa-trash-alt"></i>
      </button>
    </transition>
  </li>
</template>

<style lang="scss" scoped>
li.mobile-table-cell {
  position: relative;
  list-style-position: outside;
  list-style-type: none;
  font-size: 1.1rem;
  line-height: 1.2rem;
  color: #676a6c;
  padding: 4px;
  vertical-align: middle;
  border-left-color: transparent;
  border-left-style: solid;
  border-left-width: 6px;
  overflow: hidden;
}
li.mobile-table-cell.seperator-lines {
  border-bottom: 1px solid #e7e7e7;
}

.mobile-table-cell-accessory {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  margin-right: 10px;
  vertical-align: middle;
  color: #d0d0d0;
  font-size: 2.2rem;
}
.mobile-table-cell-delete {
  position: absolute;
  background-color: #F83533;
  border: none;
  top: 0;
  bottom: 0;
  right: 0;
  width: 60px;
  border-radius: 4px;
  margin: 2px;
  vertical-align: middle;
  text-align: center;
  color: #ffffff;
}
.mobile-table-cell .label {
  font-size: 0.7rem;
}
li.mobile-table-cell .cell-title {
  font-size: 1.1rem;
  line-height: 1.2rem;
  font-weight: 600;
}
li.mobile-table-cell .cell-content {
  color: #666666;
  font-size: 0.85rem;
}
</style>

<script>
export default {
  name: 'MobileTableCell',
  props: {
    title: String,
    description: String,
    accessory: {
      type: Boolean,
      default: true
    },
    statusColour: {
      type: String,
      default: null
    },
    seperatorLines: {
      type: Boolean,
      default: true
    },
    height: {
      type: Number,
      default: 90
    },
    showDelete: Boolean
  },
  methods: {
    onClicked(evt) {
      this.$emit('click', evt)
    },
    onDeleteClicked(evt) {
      this.$emit('deleteClick', evt)
    }
  }
}
</script>